export class FilterRequestRecon {
  usuario: String;
  fechaInicial: Date;
  fechaFinal: Date;
  estado: String;
  institucion: String;
  programa: String;
  materia: String;
  tipo: String;
}
